<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Data</th>
          <th>Hora</th>
          <th>Status</th>
          <th>Status Pagamento</th>
          <th>Profissional</th>
          <th>Unidade</th>
          <th>Especialidade</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="agendamento in agendamentos" :key="agendamento._id">
          <td>{{ formatarData(agendamento.data, 'DD/MM/YYYY') }}</td>
          <td>{{ agendamento.hora }}</td>
          <td
            :class="
              'status_agendamento agendamento-legenda-item--' +
              agendamento.status
            "
            >{{ agendamento.status }}</td
          >
          <td
            :class="
              'statusbloqueioPagamento statusbloqueioPagamento--' +
              agendamento.bloqueadoParaPagamento
            "
            >{{
              statusBloqueioPagamento(agendamento.bloqueadoParaPagamento)
            }}</td
          >
          <td>{{ agendamento.profissional.nome }}</td>
          <td>{{ agendamento.unidade }}</td>
          <td>{{ agendamento.especialidade }}</td>
          <td>
            <button
              id="botaoBloquear"
              v-tooltip.bottom="'Bloquear Pagamento'"
              data-test-id="button-botaobloquear"
              name="botaoBloquear"
              type="button"
              class="btn btn-xs btn-link"
              @click="bloquearPagamento(agendamento)"
            >
              <span class="fa fa-lock" />
            </button>
            <button
              id="botaoDesbloquear"
              v-tooltip.bottom="'Desbloquear Pagamento'"
              data-test-id="button-botaodesbloquear"
              name="botaoDesbloquear"
              type="button"
              class="btn btn-xs btn-link"
              @click="desbloquearPagamento(agendamento)"
            >
              <span class="fa fa-unlock" />
            </button>
            <button
              id="botaoRemover"
              v-tooltip.bottom="'Remover'"
              data-test-id="button-botaoremover"
              name="Remover"
              type="button"
              class="btn btn-xs btn-link"
              @click="removerAgendamento(agendamento)"
            >
              <span class="fa fa-trash" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'GuiaAgendamentosTabela',
  props: {
    agendamentos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    bloquearPagamento(agendamento) {
      this.$emit('agendamentoBloquearPagamento', agendamento._id)
    },
    desbloquearPagamento(agendamento) {
      this.$emit('agendamentoDesbloquearPagamento', agendamento._id)
    },
    removerAgendamento(agendamento) {
      this.$emit('agendamentoRemover', agendamento._id)
    },
  },
}
</script>

<style scoped>
.status_agendamento {
  font-size: 1.1em;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
